import { lazyRouteComponent, createRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { processIncomingMobilityRoute } from '../route';

export const processIncomingMobilityDocumentsPageRoute = createRoute({
	getParentRoute: () => processIncomingMobilityRoute,
	path: '/1-document-upload',
	validateSearch: z.object({
		openedDocument: z.string().optional(),
	}),
	component: lazyRouteComponent(
		() => import('./ProcessIncomingMobilityDocumentsPage'),
		'ProcessIncomingMobilityDocumentsPage',
	),
});
